import React, { ReactNode } from "react";
import { Provider } from "react-redux";
import { CapacityContext } from "./capacityStore";
import "./msg/MsgReceiver";
import capacityStore from "./capacityStore";

interface IProps {
    children: ReactNode;
}

function CapacityProvider(props: IProps) {
    return (
        <Provider store={capacityStore} context={CapacityContext}>
            {props.children}
        </Provider>
    );
}

export default CapacityProvider;
